<script setup>
import {reactive,onMounted} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {Permissions} from "@/Utils/Permissions";
import {ToastUtil} from "@/Utils/ToastUtil";

const props = defineProps({
  contextSchemaA: String,
  contextIdA: String
});

const data = reactive({
  date: null,
  peoplePaid: null,
  gross: null,
  holdbacks: null,
  releasedHoldbacks: null,
  otherCharges: null,
  net: null
});

const generateHoldbacks = () => {

  ApiWrapper.post('pay-period', 'generate-holdbacks', {id: props.contextIdA})
      .then((response) => {
        getPayPeriodStats();
        ToastUtil.successMsg('Generated holdbacks');
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
}

const getPayPeriodStats = () => {
  ApiWrapper.get('pay-period', 'stats','payPeriodId=' + props.contextIdA)
      .then((response) => {
        data.date = response.date;
        data.peoplePaid = response.peoplePaid;
        data.gross = response.gross;
        data.holdbacks = response.holdbacks;
        data.releasedHoldbacks = response.releasedHoldbacks;

        data.otherCharges = response.otherCharges;
        data.net = response.net;
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
}

onMounted(()=>{
  getPayPeriodStats();
})
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Pay Period Stats</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-row>
          <v-col cols="3">
            <RouterLink :to="'/releaseholdbacks/'+props.contextIdA">
              <v-btn
                  color="primary"
                  variant="elevated"
                  class="mt-3 mb-3"
              >
                Release Holdbacks
              </v-btn>
            </RouterLink>
          </v-col>
          <v-col cols="3">
            <RouterLink :to="'/generatenewholdbacks/'+props.contextIdA">
              <v-btn
                  color="primary"
                  variant="elevated"
                  class="mt-3 mb-3"
              >
                Generate New Holdbacks
              </v-btn>
            </RouterLink>
          </v-col>
        </v-row>
      </v-toolbar>
      <v-row density="compact">
        <v-col cols="12" sm="12">
          <h3 class="px-5" style="text-align: left">{{data.date}}</h3>
        </v-col>
      </v-row>
      <v-row density="compact" justify="space-between">
        <v-col cols="12" sm="2">
          <h1 style="text-align: center">{{data.peoplePaid}}</h1>
          <p style="text-align: center; vertical-align: bottom">
            People Paid
          </p>
        </v-col>

        <v-col cols="12" sm="2">
          <h1 style="text-align: center">{{data.gross}}</h1>
          <p style="text-align: center; vertical-align: bottom">
            Gross Pay
          </p>
        </v-col>

        <v-col cols="12" sm="2">
          <h1 style="text-align: center">{{data.holdbacks}}</h1>
          <p style="text-align: center; vertical-align: bottom">
            Holdbacks
          </p>
        </v-col>
        <v-col cols="12" sm="2">
          <h1 style="text-align: center">{{data.releasedHoldbacks}}</h1>
          <p style="text-align: center; vertical-align: bottom">
            Released Holdbacks
          </p>
        </v-col>

        <v-col cols="12" sm="2">
          <h1 style="text-align: center">{{data.otherCharges}}</h1>
          <p style="text-align: center; vertical-align: bottom">
            Received Other Charges
          </p>
        </v-col>

        <v-col cols="12" sm="2">
          <h1 style="text-align: center">{{data.net}}</h1>
          <p style="text-align: center">Net Pay</p>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<style scoped>
.container {
  padding: 5px;
}
[v-cloak] {
  display: none;
}
</style>